/** One auth epoch per document, shared by API clients, handlers and local cleanup. */
class ClientSessionLifecycle {
  private generation = 0
  private terminal = false
  private storageTail: Promise<void> = Promise.resolve()

  capture() { return this.generation }

  isCurrent(generation: number) {
    return !this.terminal && generation === this.generation
  }

  terminate() {
    if (!this.terminal) {
      this.terminal = true
      this.generation++
    }
  }

  /** In-flight native writes cannot be cancelled: the clear must run AFTER them. */
  mutateStorage(mutation: () => Promise<void>): Promise<void> {
    const operation = this.storageTail.then(mutation)
    this.storageTail = operation.catch(() => {})
    return operation
  }
}

const documents = new WeakMap<object, ClientSessionLifecycle>()

export function getClientSessionLifecycle() {
  if (typeof window === 'undefined') return undefined
  let lifecycle = documents.get(window)
  if (!lifecycle) {
    lifecycle = new ClientSessionLifecycle()
    documents.set(window, lifecycle)
  }
  return lifecycle
}

/** Deliberately pending until terminal document navigation tears down the caller. */
export function pendingSessionRequest(): Promise<never> {
  return new Promise<never>(() => {})
}
